import { Dropdown, Option } from "@fluentui/react-components";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";
import { useAtom } from "jotai";
import { ETaxonomy } from "library/types";
import React from "react";
import { filterPaymentMethodAtom } from "store/UIHrPageDashboard";
import { useTranslation } from "react-i18next";

const FilterPaymentMethod = () => {
  const paymentMethodOptions = useTaxonomyOptions(ETaxonomy.PaymentMethod);
  const [filterPaymentMethod, setFilterPaymentMethod] = useAtom(
    filterPaymentMethodAtom
  );
  const { t } = useTranslation();

  const handleOptionSelect = (ev, data) => {
    if (data.optionValue === "") {
      setFilterPaymentMethod({
        code: "PaymentMethod.All",
        text: "",
        value: "",
      });
      return;
    }
    setFilterPaymentMethod(
      paymentMethodOptions.find((e) => e.value === data.optionValue)
    );
  };

  // The "All" entry carries no text of its own (see filterPaymentMethodAtom) —
  // translate it here so it survives load order and language changes.
  const selectedText =
    filterPaymentMethod?.value === ""
      ? t("hbh.filterPaymentMethod.all")
      : filterPaymentMethod?.text || "";

  return (
    <Dropdown
      placeholder={t("hbh.filterPaymentMethod.placeholder")}
      title={t("hbh.filterPaymentMethod.title")}
      style={{ marginTop: "10px" }}
      value={selectedText}
      onOptionSelect={handleOptionSelect}
    >
      <Option key={"All"} defaultChecked={true} value="">
        {t("hbh.filterPaymentMethod.all")}
      </Option>
      {paymentMethodOptions
        .sort((a, b) => a.text.localeCompare(b.text))
        .map((option) => (
          <Option key={option.code} value={option.value}>
            {option.text}
          </Option>
        ))}
    </Dropdown>
  );
};

export default FilterPaymentMethod;
